module.exports = __webpack_public_path__ + "img/qupic-moke-up.047c2f25.jpg";